export const directions = {
  in: 'inbound',
  out: 'outbound',
};

export const roles = {
  caller: 'caller',
  callee: 'callee',
};